'use strict';

angular.module('app')

.directive('uefaRegisterForm', function ()
{
    return {
        restrict: 'E',
        scope: {},
        bindToController: {
            onRegister: '&',
            noLogin: '=',
            showInterestField: '=',
            addGift: '='
        },
        controller: 'UefaRegisterFormCtrl',
        controllerAs: '$ctrl',
        templateUrl: 'directives/register/uefaRegisterForm.html'
    };
})

.controller('UefaRegisterFormCtrl', function (
    $scope,
    DS,
    $http,
    kdLogin,
    $filter
) {
        this.url = DS.defaults.basePath + 'register';

        if (this.noLogin) {
            this.url = DS.defaults.basePath + 'createUser';
        }

        this.error = null;
        this.user = {};

        this.user.newsletter = false;
        this.user.agree_uefa = false;
        this.user.agree_partners = false;

        if (this.addGift) {
            this.user.email = this.addGift.email;
        }

        this.interests = [
            {key: 'ucl', 'name' : 'UEFA Champions League'},
            {key: 'uel', 'name' : 'UEFA Europa League'},
            {key: 'uel', 'name' : 'UEFA Women\'s Champions League'},
            {key: 'usc', 'name' : 'UEFA Super Cup'},
            {key: 'all', 'name' : 'All of the above'}
        ];

        this.submit = function ()
        {
            this.error = null;

            var user = angular.copy(this.user);

            if (this.addGift) {
                user.gift = this.addGift.uuid;
            }

            if (this.campaign) {
                user.campaign_id = this.campaign.id;
            }

            user.dob = $filter('date')(user.dob, "yyyy-MM-dd");

            $http.post(this.url, user)
                .then(this.onSuccessResponse.bind(this))
                .catch(this.onBadResponse.bind(this));
        };

        this.onSuccessResponse = function (response)
        {
            var user;

            if (!this.noLogin) {
                user = kdLogin.onLoginSuccess(response.data);
            } else {
                user = DS.inject('User', response.data);
                this.user = {};
            }


            var callback = this.onRegister();
            if (callback) {
                callback(user);
            }
        };

        this.onBadResponse = function (response)
        {
            if (response.status === 422) {
                return;
            }

            if (response.status === 500) {
                this.error = 'Something went wrong, please try again later.';
                return;
            }

            this.error = response.data;
        };
    });
